import { HttpClient } from '@angular/common/http';
import { IAppResult } from '@app/core/model/appresults/appresult';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { AppResultSearchColumnFields, AppResultSearchGridOptionsFormatter } from '@app/search/gridOptions/app-result-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';

export class AppResultResourceMatcherGridOptionsFormatter extends AppResultSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public http: HttpClient
  ) {
    super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<AppResultSearchColumnFields> {
    const inclusiveColumns: AppResultSearchColumnFields[] = [
      AppResultSearchColumnFields.Name,
      AppResultSearchColumnFields.Analysis,
      AppResultSearchColumnFields.Project,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<AppResultSearchColumnFields>[] = [
      {
        colId: AppResultSearchColumnFields.Name,
        cellRendererParams: (params) => {
          if (params.data && params.data.AppResult && params.data.AppResult.AppSession && !params.data.AppResult.IsDeleted && !params.data.AppResult.IsArchived) {
            const resource = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as IAppResult;
            const analysis = resource.AppSession;
            return DataTableUtilities.getRadLinkParams(
              resource.Name,
              BsApiEndPoints.getAppResultRoute(analysis.Id, resource.Id),
              null,
              null,
              70
            );
          } else if (params.data && params.data.AppResult) {
            const resource = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as IAppResult;
            return DataTableUtilities.getRadLinkParams(
              resource.Name,
              null,
              null,
              null,
              70
            );
          } else {
            return {};
          }
        }
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}

